import { User } from 'shared/types';
import { useAppSelector } from 'store/shared/hooks';

export const useCurrentUser = (): User => useAppSelector(state => state.auth.user?.data as User);
